import { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import { loginWithTwitch, loginWithYoutube } from '../InternetAccounts/Utils'
import { login, verify } from '../../Utils/Authentication'
import { GreenButton, GreyButton, DarkButton } from '../SpiceUI/MUI';
import Button from '@mui/material/Button'

import { FaYoutube } from "react-icons/fa";


export function Center( props )
{
    return (
        <div className="d-flex justify-content-center" style={{ width:'100%'}}>
            { props.children }
        </div>
    )
}

export default function MobileBanner( props )
{
    return (
        <div
             style={{
                width: '400px', height: '200px', backgroundColor: 'white', 
                padding:'10px', borderRadius: '10px'
        }}>
            <Center>
                <p style={{fontSize:'25px',color:'#5C9286',marginBottom:'10px'}}>Spice Up Your Stream</p>
            </Center>
            <Center>
                <p style={{margin:'0px'}} >Using AI, we create smart stream widgets that</p>
            </Center>
            <Center>
                <p style={{margin:'0px'}}>are aware of and react to the stream content.</p>
            </Center>
            <Center>
                <p style={{margin:'0px'}}>Check our video demo on youtube</p>
            </Center> 
            <Center>
                <a href="https://www.youtube.com/watch?v=x1UxB4-wjYs">
                    <FaYoutube style={{ fontSize:45, color:"#FF0000" }}/>
                </a>
            </Center>

            <Center>
                Signin using a desktop browser 
            </Center>

            
            {/*
            <div>
                <GreenButton style={{ width: '220px' }}>
                    Login using a desktop browser
                </GreenButton>
            </div>
            */}
        </div>
    )
}

